(() => {
  const sectionId = "shopify-section-template--20019233685574__16225316461d1cff80";
  const innerId = "m-collection-list-template--20019233685574__16225316461d1cff80";
  const styleId = "codex-hide-deprecated-homepage-yarn-type-style";
  const readyPicksSectionId = "shopify-section-template--20019233685574__featured_collection_E3MP8x";
  const readyPicksCollectionUrl = "/collections/ready-to-start-yarn-picks";
  const readyPicksOldHandle = "100-acrylic-multicolor-yarn-for-crocheting-and-knitting";
  const readyPicksTargetHandle = "80g-sparkle-silver-lurex-thread";
  const faqUrl = "/pages/yarn-help-faq";
  const faqLabel = "FAQ";
  const collectionBriefs = {"avada-best-sellers":{"intro":"Best selling yarn for crochet, knitting, scarves, bags, amigurumi, plush gifts, and everyday handmade projects.","keywords":["best selling yarn","crochet yarn","knitting yarn","soft yarn","handmade gifts"]},"all-yarn-1":{"intro":"Shop cotton, soft, chenille, metallic, acrylic, wool blend, and cake yarn for crochet, knitting, DIY crafts, and gifts.","keywords":["all yarn","crochet yarn","knitting yarn","cotton yarn","soft yarn","cake yarn"]},"beginner-yarn":{"intro":"Beginner-friendly yarn with smooth texture and clear stitches for first crochet, knitting, scarves, bags, and amigurumi.","keywords":["beginner yarn","easy crochet yarn","clear stitch yarn","soft acrylic yarn","cotton yarn"]},"crochet-yarn":{"intro":"Crochet yarn for amigurumi, dolls, bags, blankets, scarves, baby items, home decor, and handmade gifts.","keywords":["crochet yarn","amigurumi yarn","cotton yarn","soft yarn","yarn for handmade gifts"]},"soft-yarn":{"intro":"Soft yarn for crochet and knitting projects that need a gentle touch, including scarves, blankets, plush toys, baby gifts, and cozy decor.","keywords":["soft yarn","chenille yarn","baby gift yarn","plush crochet yarn","cozy knitting yarn"]},"cake-yarn":{"intro":"Cake yarn with color-change effects for scarves, shawls, blankets, bags, cushions, and colorful crochet or knitting projects.","keywords":["cake yarn","color change yarn","gradient yarn","crochet scarf yarn","knitting yarn"]},"metallic-yarn":{"intro":"Metallic yarn and sparkle thread for crochet ornaments, keychains, trims, bags, festive decor, and shiny handmade gifts.","keywords":["metallic yarn","sparkle yarn","lurex thread","ornament yarn","DIY craft yarn"]}};
  let readyPicksRequest = null;
  let readyPicksApplied = false;

  function installStyle() {
    if (document.getElementById(styleId)) return;
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent =
      "#" + sectionId + ",#" + innerId + "{display:none!important;visibility:hidden!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}" +
      ".codex-collection-brief{display:grid;gap:11px;max-width:780px;margin:0 auto;text-align:center}.codex-collection-brief p{margin:0;color:#62594f;font-size:16px;line-height:1.55;letter-spacing:0}.codex-collection-keywords{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:0;padding:0;list-style:none}.codex-collection-keywords li{display:inline-flex;min-height:28px;align-items:center;padding:4px 10px;border:1px solid rgba(91,117,95,.22);border-radius:999px;background:rgba(255,253,248,.82);color:#4e664f;font-size:12px;font-weight:700;line-height:1.25;letter-spacing:0;text-transform:lowercase}@media(max-width:767px){.codex-collection-brief{gap:10px;text-align:left}.codex-collection-brief p{font-size:14px;line-height:1.5}.codex-collection-keywords{justify-content:flex-start;gap:7px}.codex-collection-keywords li{min-height:26px;padding:4px 8px;font-size:11px}}";
    document.head.appendChild(style);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function getCollectionHandle() {
    const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function isHome() {
    const normalizedPath = window.location.pathname.replace(/\/+$/, "");
    return normalizedPath === "" || document.body.classList.contains("template-index");
  }

  function hasFaqLink(container) {
    return !!(container && container.querySelector('a[href="' + faqUrl + '"]'));
  }

  function makeDesktopFaqItem() {
    const li = document.createElement("li");
    li.className = "m-menu__item codex-faq-menu-item";
    li.setAttribute("data-index", "0");
    li.innerHTML = '<a href="' + faqUrl + '" class="m-menu__link m-menu__link--main">' + faqLabel + "</a>";
    return li;
  }

  function makeMobileFaqItem() {
    const li = document.createElement("li");
    li.className = "m-menu-mobile__item codex-faq-menu-item";
    li.setAttribute("data-url", faqUrl);
    li.setAttribute("data-index", "0");
    li.innerHTML = '<a href="' + faqUrl + '" class="m-menu-mobile__link"><span>' + faqLabel + "</span></a>";
    return li;
  }

  function insertAfterHome(menu, item) {
    if (!menu || hasFaqLink(menu)) return;
    const home = menu.querySelector(".codex-home-menu-item");
    if (home && home.parentNode === menu) home.insertAdjacentElement("afterend", item);
    else menu.insertBefore(item, menu.firstElementChild || null);
  }

  function addFaqNav() {
    insertAfterHome(document.querySelector(".m-header__menu .m-menu"), makeDesktopFaqItem());
    insertAfterHome(document.querySelector(".m-menu-drawer__navigation.m-menu-mobile"), makeMobileFaqItem());
  }

  function buildBriefHtml(brief) {
    return [
      '<div class="codex-collection-brief">',
      '<p>' + escapeHtml(brief.intro) + '</p>',
      '<ul class="codex-collection-keywords" aria-label="Popular yarn search keywords">',
      brief.keywords.map((keyword) => '<li>' + escapeHtml(keyword) + '</li>').join(''),
      '</ul>',
      '</div>'
    ].join('');
  }

  function hideDeprecatedBlock() {
    installStyle();
    const section = document.getElementById(sectionId);
    const inner = document.getElementById(innerId);
    if (section) section.remove();
    else if (inner) inner.remove();
  }

  function replaceStaleCollectionIntro() {
    installStyle();
    const brief = collectionBriefs[getCollectionHandle()];
    if (!brief) return;
    const description =
      document.querySelector('.m-collection-page-header__description .read-more__content') ||
      document.querySelector('.m-collection-page-header__description');
    if (!description || description.querySelector('.codex-collection-brief')) return;
    description.innerHTML = buildBriefHtml(brief);
  }

  async function replaceStaleReadyPicksCard() {
    if (!isHome() || readyPicksApplied) return;
    const section = document.getElementById(readyPicksSectionId);
    if (!section) return;
    if (section.querySelector('a[href*="/products/' + readyPicksTargetHandle + '"]')) {
      readyPicksApplied = true;
      return;
    }

    const oldLink = section.querySelector('a[href*="/products/' + readyPicksOldHandle + '"]');
    if (!oldLink) return;

    const oldCard = oldLink.closest(".m-product-card");
    if (!oldCard) return;

    if (!readyPicksRequest) {
      readyPicksRequest = fetch(readyPicksCollectionUrl + "?codex_ready_picks=" + Date.now(), {
        credentials: "same-origin",
        headers: { Accept: "text/html" }
      })
        .then((response) => response.text())
        .then((html) => new DOMParser().parseFromString(html, "text/html"))
        .catch(() => null);
    }

    const doc = await readyPicksRequest;
    if (!doc) return;

    const targetLink = doc.querySelector('a[href*="/products/' + readyPicksTargetHandle + '"]');
    const targetCard = targetLink ? targetLink.closest(".m-product-card") : null;
    if (!targetCard) return;

    oldCard.replaceWith(targetCard.cloneNode(true));
    readyPicksApplied = true;
  }

  function run() {
    addFaqNav();
    hideDeprecatedBlock();
    replaceStaleCollectionIntro();
    replaceStaleReadyPicksCard();
  }

  run();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  }
  window.addEventListener("load", run, { once: true });

  let tries = 0;
  const timer = window.setInterval(() => {
    tries += 1;
    run();
    if (tries >= 30) window.clearInterval(timer);
  }, 300);

  if ("MutationObserver" in window) {
    const observer = new MutationObserver(run);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }
})();

/* Codex sunflower phone bag gallery bootstrap start */
(function(){
  if (window.__codexSunflowerPhoneBagGalleryBootstrap) return;
  window.__codexSunflowerPhoneBagGalleryBootstrap = true;
  if (location.pathname.indexOf('/products/beginner-sunflower-phone-bag-crochet-kit') === -1) return;
  var script = document.createElement('script');
  script.src = 'https://cnfancyyarn.com/cdn/shop/t/8/assets/codex-sunflower-phone-bag-gallery.js?v=1782122934';
  script.async = true;
  document.head.appendChild(script);
})();
/* Codex sunflower phone bag gallery bootstrap end */

/* Codex penguin gallery override 2026-06-23 */
(function(){
  var handle='beginner-penguin-crochet-kit';
  if(location.pathname.indexOf('/products/'+handle)===-1)return;
  var userBrowsingUntil=0;
  function inGallery(el){return !!(el&&el.closest&&el.closest('.m-product-media,.m-product-media--item,.m-product-media__nav,.swiper-thumbs,.m-product-media__slider,.m-product-media__thumbnails,.product__media-list,.product__media-item')) && !(el.closest('variant-picker,.m-product-option,.m-product-option--node,[data-option-position],[data-option-value]'));}
  document.addEventListener('click',function(e){if(inGallery(e.target))userBrowsingUntil=Date.now()+4500;},true);
  document.addEventListener('touchstart',function(e){if(inGallery(e.target))userBrowsingUntil=Date.now()+4500;},true);
  function patchSwiper(sw){
    if(!sw||sw.__codexPenguinPatched||typeof sw.slideTo!=='function')return;
    var original=sw.slideTo;
    sw.__codexPenguinPatched=true;
    sw.slideTo=function(index,speed){
      if(Date.now()<userBrowsingUntil && speed===0){try{if(typeof sw.update==='function')sw.update();}catch(e){} return sw;}
      return original.apply(this,arguments);
    };
  }
  function patchAll(){document.querySelectorAll('.swiper-container,.swiper').forEach(function(el){if(el.swiper)patchSwiper(el.swiper);});}
  patchAll();setInterval(patchAll,500);
})();
